import React, { useEffect, useState } from "react";
import { Alert, Drawer, Form } from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ComuneInput from "../../Form/ComuneInput";
import MEFDocs from "./docs";

/**
 * @param {boolean} visible
 * @param {function} onClose
 * @param {{code: string, description: string}|null} comune comune dell'utenza (code = codice istat)
 */
const MEFDrawer = ({ visible, onClose, comune }) => {
   //codice istat del comune selezionato
   const [comuneCode, setComuneCode] = useState(comune?.code ?? null);

   //All'apertura o se cambia il comune passato (es. cambio pagina) ripropone il comune dell'utenza
   useEffect(() => {
      if (visible) {
         setComuneCode(comune?.code ?? null);
      }
   }, [visible, comune?.code]);

   return (
      <Drawer
         title={<IntlMessages id="common.osservatorio-tari" />}
         placement="right"
         width={560}
         visible={visible}
         onClose={onClose}
         //il tema azzera il padding del body dei drawer
         bodyStyle={{ padding: 24 }}
      >
         <Alert
            message={<IntlMessages id="osservatorio-tari.description" />}
            type="info"
            showIcon
            style={{ marginBottom: 24 }}
         />
         <Form layout="horizontal" style={{ paddingLeft: 16, paddingRight: 16 }}>
            <Form.Item
               label={<IntlMessages id="common.comune" />}
               labelCol={{ flex: "none" }}
            >
               <ComuneInput
                  value={comuneCode}
                  onChange={(value) => setComuneCode(value ?? null)}
                  allowClear
                  style={{ width: 300 }}
               />
            </Form.Item>
         </Form>
         {visible && comuneCode && <MEFDocs comuneCode={comuneCode} />}
      </Drawer>
   );
};

export default MEFDrawer;
